<!-- src/components/admin/TrafficTrendChart.vue -->
<template>
  <div class="chart-section">
    
    <div class="chart-header">
      <h4 class="section-title">流量与命中趋势</h4>
      <div class="chart-controls">
    </div>

      </div>

    
    <el-card class="chart-card" v-loading="loading">
      <div class="chart-container" ref="chartContainer"></div>
      <div v-if="!loading && (!trendData || trendData.length === 0)" class="empty-data">
        <i class="el-icon-info"></i>
        <span>暂无趋势数据</span>
      </div>      
    </el-card>
  </div> 
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: "TrafficTrendChart",
  props: {
    trendData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
// ========== 新增 props ==========
    timeGroupBy: {
      type: String,
      default: 'DAY'
    },
    dateRange: {
      type: Array,
      default: () => []
    }
    // ================================    
  },
  data() {
    return {
//      timeGroupBy: 'DAY',
//      dateRange: [],
      chartInstance: null
    }
  },
    // ========== 新增：计算属性 ==========
  computed: {
    timeGroupByText() {
      const map = {
        'HOUR': '按小时',
        'DAY': '按天',
        'WEEK': '按周',
        'MONTH': '按月'
      }
      return map[this.timeGroupBy] || '按天'
    }
  },
  // ================================
  watch: {
    trendData: {
      handler() {
        this.$nextTick(() => {
          this.renderChart()
        })
      },
      deep: true
    }
  },
  mounted() {
    console.log("trendData", this.trendData)
    
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose()
    }
  },
  methods: {    
    initChart() {
      if (!this.$refs.chartContainer) return
      this.chartInstance = echarts.init(this.$refs.chartContainer)
      this.renderChart()
      
      // 响应式
      window.addEventListener('resize', this.handleResize)
    },
    
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    },
    
    renderChart() {
      if (!this.chartInstance) return
      if (!this.trendData || this.trendData.length === 0) {
        this.chartInstance.clear()
        return
      }
      
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' }
        },
        legend: {
          data: ['总提问', '命中', '未知问题'],
          bottom: 0
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.trendData.map(item => item.time_point)  // ✅ 改为 time_point
        },
        yAxis: {
          type: 'value',
          minInterval: 1
        },
        series: [
          {
            name: '总提问',
            type: 'line',
            smooth: true,
            symbol: 'none',
            lineStyle: { width: 3 },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(64, 158, 255, 0.3)' },
                { offset: 1, color: 'rgba(64, 158, 255, 0.05)' }
              ])
            },
            data: this.trendData.map(item => item.total_queries || 0)  // ✅ 改为 total_queries
          },
          {
            name: '命中',
            type: 'line',
            smooth: true,
            symbol: 'none',
            lineStyle: { width: 2, color: '#67c23a' },
            data: this.trendData.map(item => item.hit_queries || 0)  // ✅ 改为 hit_queries
          },
          {
            name: '未知问题',
            type: 'line',
            smooth: true,
            symbol: 'none',
            lineStyle: { width: 2, color: '#f56c6c', type: 'dashed' },
            data: this.trendData.map(item => (item.total_queries - item.hit_queries) || 0)  // ✅ 改为 total_queries 和 hit_queries
          }
        ]
      }
      
      this.chartInstance.setOption(option, true)
    },         
  }
}
</script>

<style scoped>
/* ========== 新增：时间范围信息样式 ========== */
.current-range-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.range-text {
  font-size: 13px;
  color: #909399;
}
/* ========================================= */

.chart-section {
  margin-top: 20px;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 10px;
}

.chart-controls {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.chart-card {
  border-radius: 8px;
}

.chart-container {
  width: 100%;
  height: 400px;
}

.empty-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 360px;
  color: #909399;
  gap: 10px;
}

.empty-data i {
  font-size: 48px;
  color: #dcdfe6;
}

@media (max-width: 768px) {
  .chart-container {
    height: 280px;
  }
  
  .chart-header {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>